<template>

    <el-row ref="pdfReviewRef" class="pdf-review">
        <el-col style="display:flex;justify-content: center;">
            <span class="pdf-title">Invoice</span>
        </el-col>
        <el-col :span="20">
            <p>&nbsp;</p>
            <p class="sub-title">PIKAKADS LIMITED</p>
            <p>ROOM 13,FLAT A,7/F HOUSE OF CORONA,50 HUNG TO ROAD,KWUN TONG,KOWLOON,HONG KONG</p>
            <p></p>
            <p>Tax No.: 77512236</p>
            <p>admin@pikakads.com</p>
            <p>&nbsp;</p>
        </el-col>
        <el-col :span="4">
            <p>&nbsp;</p>
            <img src="../../assets/logo_rectangle.png" width="200px" />
        </el-col>
        <el-col>
            <p class="sub-title">Billing to:</p>
            <p v-html="advInfo.billing_info"></p>
        </el-col>
        <el-col>
            <p>Billing currency: {{ invoiceType }}</p>
            <p>Item: Mobile Advertising Services</p>
            <p>Invoice Date: {{ nowDate }}</p>
            <p>Invoice No. {{ invoiceNo }}</p>
        </el-col>
        <el-col>
            <el-table
                :data="tableData"
                style="width:100%;"
                stripe
                border
                class="export-list-table"
                cell-class-name="export-list-table-cell"
                header-row-class-name="export-list-table-header"
            >
                <el-table-column prop="time" label="Month" />
                <el-table-column min-width="300" prop="item" label="Description" />
                <el-table-column min-width="100" prop="confirm_amount" :label="`Amount (${invoiceObj[invoiceType].icon})`" />
            </el-table>
        </el-col>
        <el-col>
            <p class="sub-title">Bank info:</p>
            <p>&nbsp;</p>
            <p>Account name: Pikakads Limited</p>
            <p>Address: ROOM 13,FLAT A,7/F HOUSE OF CORONA,50 HUNG TO ROAD,KWUN TONG,KOWLOON,HONG KONG</p>
            <p>Bank account number: 7950195606</p>
            <p>Bank code: 016</p>
            <p>Branch code: 478</p>
            <p>SWIFT code: DHBKHKHH</p>
            <p>Bank name: DBS Bank (Hong Kong) Limited	</p>
            <p>Bank address: 18th Floor, The Center, 99 Queen’s Road Central, Central, Hong Kong SAR</p>
            <p></p>
            <p>Payoneer: <a href="mailto:latte@pikakads.com">latte@pikakads.com</a></p>
            <p>Paypal: <a href="mailto:admin@pikakads.com">admin@pikakads.com</a></p>
        </el-col>
        <div class="invoice-img">
            <img src="../../assets/invoice.png" width="344px" />
        </div>
    </el-row>
</template>

<script>
export default {
    props: {
        invoiceType: {
            type: String,
        },
        advInfo: {
            type: Object,
        },
        exportList: {
            type: Array,
        },
        nowDate: {
            type: String,
        },
        invoiceNo: {
            type: String,
        }
    },
    data() {
        return {
            invoiceObj: {
                'USD': {
                    SWIFT: 'SCBLHKHH',
                    bankName: 'Standard Chartered Bank (Hong Kong) Ltd',
                    bankAddress: '32nd Floor, 4-4A Des Voeux Road Central Hong Kong SAR',
                    icon: '$',
                    emailBody: `
Hi  team, 

Attached invoice of {invoice_name} from PIKAKADS. 

Thanks

BR
PIKAKADS`
                },
            },
        }
    },
    computed: {
        tableData() {
            return this.exportList.map((item, key) => {
                item.item = 'Mobile Advertising Services';
                if (key == this.exportList.length - 1) {
                    item.item = '';
                }   
                item.confirm_amount = item.confirm_amount ? Number(item.confirm_amount).toFixed(2) : '0.00';
                return item;
            })
        }
    }
}
</script>

<style scoped>
.pdf-review {
    padding: 100px 120px;
    color: #000;
    position: relative;
    font-family: Arial !important;
    :deep() {
        p {
            font-size: 18px;
            margin: 12px 0;
        }
    }
    .sub-title {
        font-size: 26px !important;
        font-weight:700;
    }
    
}
.invoice-img {
    position: absolute;
    left:50%;
    bottom: 100px;
}
.pdf-title {
    /* font-size: 46px; */
    font-size: 48px !important;
    font-weight: 800;
    color: #13a195;
}
</style>
<style>
.export-list-table-cell {
    font-size: 18px;
}
.export-list-table-header >th {
    background-color: #13a195;
    color: #fff;
    font-size: 18px;
    font-weight: 800;
}
</style>